import { typesApp } from './typesModuleApp';

export const actions = {
  [typesApp.actions.UPDATE_IS_POSTING]({ commit }, payload) {
    commit(typesApp.mutations.SET_IS_POSTING, payload);
  },
  [typesApp.actions.UPDATE_RECAPTCHA_ID]({ commit }, payload) {
    commit(typesApp.mutations.SET_RECAPTCHA_ID, payload);
  },
};

export default {};
